import AdLabel from '@/components/AdLabel/AdLabel'
import { Image } from '@/components/Image'
import { Typography } from '@/components/Typography'
import { type ImageData } from '@/elements/widgets/external/ExternalInline'
import styles from './ShopTeaser.module.scss'

export type ShopTeaserProps = {
  url?: string
  nofollow?: string
  price?: string
  listPrice?: string
  txt?: string
  reviewsCount?: string
  reviewsStarRating?: string
  isPrimeEligible?: string
  buttonTxt?: string
  imageData?: ImageData
  imgSrc?: string
}

const ShopTeaser = ({ props }: { props: ShopTeaserProps }) => {
  const {
    url,
    nofollow,
    price,
    listPrice,
    txt,
    reviewsCount,
    reviewsStarRating,
    isPrimeEligible,
    buttonTxt,
    imageData,
    imgSrc,
  } = props

  return (
    <div>
      <AdLabel />
      <div className={styles.teaser}>
        {(imageData || imgSrc) && (
          <div className={styles.media}>
            <a href={url} target="_blank" rel={nofollow && nofollow === 'true' ? 'nofollow' : undefined}>
              {imageData && <Image image={imageData} alt={imageData.filename} />}
              {imgSrc && <img src={imgSrc} alt="" />}
            </a>
          </div>
        )}
        <div className={styles.content}>
          <Typography as="span" variant="m">
            {txt}
          </Typography>
          {reviewsStarRating && (
            <div className={styles.rating}>
              <div className={styles['rating-stars']}>
                <div style={{ width: Number(reviewsStarRating) * 20 + '%' }}></div>
              </div>
              {reviewsCount && (
                <Typography as="div" variant="s" color="darkgrey">
                  {reviewsCount}
                </Typography>
              )}
            </div>
          )}
          <div className={styles.price}>
            <Typography as="span" variant="m" weight="bold">
              {price}
            </Typography>
            {listPrice && (
              <Typography as="span" variant="s">
                {listPrice}
              </Typography>
            )}
            {isPrimeEligible && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="50"
                height="14"
                viewBox="0 0 50 14"
              >
                <defs>
                  <path id="qzwrr98fha" d="M0 0L10.676 0 10.676 9.777 0 9.777z" />
                </defs>
                <g fill="none" fillRule="evenodd">
                  <g>
                    <path
                      fill="#2193C2"
                      d="M26.258 3.438c.052-.01.106-.014.16-.014h1.415c.105.005.23.015.3.106.07.102.06.231.06.348v6.656c.002.108.003.227-.062.32-.068.092-.191.108-.297.11h-1.442c-.102-.002-.215-.017-.287-.096-.076-.083-.084-.203-.085-.31V3.805c.003-.089.007-.185.06-.261.038-.061.109-.092.178-.106M26.964 0h.278c.295.02.593.124.805.335.21.203.313.497.309.785.01.249-.047.506-.194.71-.191.266-.507.426-.83.46-.365.041-.763-.01-1.06-.238-.228-.168-.372-.435-.402-.714-.04-.313.012-.654.213-.907.21-.269.547-.408.881-.431M13.46 5.229c-.003 1.29 0 2.58-.002 3.87.542.332 1.207.469 1.835.363.405-.067.763-.34.94-.71.256-.534.282-1.142.278-1.724-.008-.385-.044-.774-.155-1.145-.075-.244-.19-.483-.372-.667-.216-.219-.517-.337-.82-.37-.59-.063-1.194.085-1.704.383m-.207-1.103c.783-.731 1.92-1.063 2.974-.867.62.107 1.196.445 1.594.933.537.636.788 1.466.858 2.285.067.833.012 1.692-.28 2.482-.247.663-.658 1.286-1.252 1.687-.475.332-1.061.489-1.639.48-.734-.007-1.487-.233-2.048-.719-.003 1.092 0 2.184-.001 3.277-.004.088-.021.188-.093.248-.077.058-.178.066-.271.068H11.66c-.107-.002-.23-.02-.299-.112-.052-.064-.043-.154-.058-.23V3.74c0-.234.133-.308.356-.315.343-.002.686 0 1.029-.001.09 0 .183.004.265.046.095.047.16.14.188.24l.112.416M33.111 3.503c.438-.18.908-.28 1.382-.296.434-.016.882.037 1.275.231.311.154.572.404.744.704.48-.308.984-.59 1.534-.753.435-.132.891-.193 1.346-.184.398.01.802.087 1.15.288.339.194.607.505.756.865.12.286.172.596.183.904v5.369c-.003.099-.027.21-.112.272-.073.052-.167.058-.253.06H39.68c-.095-.002-.2-.016-.271-.087-.078-.076-.091-.192-.093-.295v-4.82c-.013-.235-.068-.487-.237-.663-.157-.168-.394-.232-.618-.236-.571-.01-1.136.14-1.65.382v5.362c-.001.11-.024.242-.127.306-.084.05-.186.052-.282.052h-1.386c-.096-.002-.202-.015-.276-.083-.073-.07-.093-.177-.094-.274V5.81c-.007-.25-.059-.519-.235-.708-.15-.163-.375-.23-.59-.239-.588-.018-1.173.135-1.699.395v5.372c-.002.104-.03.222-.124.282-.077.046-.172.05-.26.052h-1.41c-.101-.002-.216-.017-.286-.097-.072-.075-.082-.185-.084-.284V3.806c.002-.1.009-.212.08-.29.082-.082.206-.09.315-.092.359.002.718-.002 1.076.002.153 0 .307.09.358.239.05.158.093.32.144.478.376-.243.764-.47 1.18-.64M45.2 5.138c-.326.35-.455.832-.516 1.294.468.094.947.124 1.424.118.268-.01.542-.036.794-.136.18-.071.343-.203.429-.381.09-.189.095-.406.069-.61-.031-.218-.147-.43-.336-.548-.24-.152-.535-.18-.813-.174-.388.004-.787.144-1.052.437m-.32-1.657c.518-.206 1.08-.28 1.634-.277.482.006.972.067 1.421.25.442.177.837.48 1.1.88.217.33.331.722.353 1.116.03.444-.039.91-.274 1.294-.23.382-.608.653-1.015.82-.524.213-1.092.29-1.654.312-.599.019-1.205-.004-1.79-.152.043.447.151.914.451 1.262.263.308.66.459 1.05.523.481.076.973.055 1.455-.007.348-.05.692-.133 1.032-.22.106-.03.232-.063.331.004.094.064.108.19.112.294-.001.247.001.494-.001.74-.008.124-.02.27-.13.347-.153.112-.342.155-.518.218-.521.168-1.065.264-1.612.29-.502.026-1.009 0-1.5-.108-.446-.098-.879-.274-1.252-.54-.37-.264-.68-.614-.896-1.014-.235-.43-.37-.908-.433-1.392-.073-.56-.07-1.129.005-1.688.108-.81.424-1.61 1.002-2.199.315-.33.705-.588 1.13-.753M23.506 3.525c.31-.124.645-.182.978-.172.145.003.31-.02.431.075.087.075.093.2.097.306v1.192c-.002.125-.01.282-.128.355-.162.085-.352.045-.526.037-.523-.05-1.05.027-1.556.155-.173.044-.344.1-.509.17v4.963c0 .1-.017.21-.094.282-.07.062-.17.073-.26.076h-1.441c-.102-.001-.217-.015-.29-.092-.075-.077-.087-.189-.088-.29V3.782c.004-.098.018-.209.095-.28.079-.063.185-.075.283-.077h1.057c.099 0 .201.019.281.079.083.06.126.158.148.253.064.261.125.523.19.784.38-.41.806-.802 1.332-1.015"
                    />
                    <g transform="translate(0.000000, 3.438224)">
                      <mask id="614k8gx8pb" fill="#fff">
                        <use xlinkHref="#qzwrr98fha" />
                      </mask>
                      <path
                        fill="#F8991D"
                        d="M8.282 0h2.145c.21 0 .33.22.187.443l-5.87 9.06c-.125.175-.178.274-.35.274-.17 0-.224-.099-.348-.274L.062 4.561C-.08 4.34.04 4.12.25 4.12h2.144l1.861 2.37L8.282 0z"
                        mask="url(#614k8gx8pb)"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            )}
          </div>

          <a href={url} target="_blank" rel={nofollow && nofollow === 'true' ? 'nofollow' : undefined}>
            <button className="button primary">{buttonTxt}</button>
          </a>
        </div>
      </div>
    </div>
  )
}

export default ShopTeaser
